import Swal from 'sweetalert2'

$(document).ready(function() {

	const historyReportRequestLead = {
        isLoading: false,
        init() {
            $(document).on('click', '#history-report-request-send-btn', this, this.send);
        },
		send(event) {
			const _this = event.data;
			event.preventDefault();

			if (_this.isLoading) {
                return false;
            }

			let errors = false;
			$('#history-report-request').find('.form-control').removeClass('is-invalid');
			$('#history-report-request').find('.form-check-input').removeClass('is-invalid');

			if ($('#name').val() == '') {
				$('#name').addClass('is-invalid');
				errors = true;
			}
			if ($('#email').val() == '') {
				$('#email').addClass('is-invalid');
				errors = true;
			}
			if ($('#phone').val() == '') {
				$('#phone').addClass('is-invalid');
				errors = true;
			}
			if (!$('#terms-and-conditions').is(":checked")) {
				$('#terms-and-conditions').addClass('is-invalid');
				errors = true;
			}

			if (errors) {
				$('#history-report-notifications').html('<div class="alert alert-danger" role="alert">Va rugam completati toate campurile!</div>');
				return false;
			}

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values = 'id=' + $(this).data('id');
			values += '&name=' + $('#name').val();
			values += '&email=' + $('#email').val();
			values += '&phone=' + $('#phone').val();
			values += '&newsletter=' + ($('#newsletter').is(':checked')?1:0);
			values += '&_token=' + $("meta[name=csrf-token]").attr('content');
			$.ajax({
	            type: "POST",
	            url: $(element).data('route'),
	            data: values,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#' + errorKey).addClass('is-invalid');
                                //errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }
						Swal.fire({
							//icon: 'success',
							title: 'Eroare!',
							html: response.message
						});
                        return false;
                    }

					if (response.status == 1) {
						$('#modalHistory').modal('hide');
						
						$('#history-report-request').find('.form-control').val('');
						$('#history-report-request').find('.form-check-input').attr('checked', false);

						Swal.fire({
							//icon: 'success',
							title: 'Success!',
							html: response.message
						});

						// if (cookies_advertisement == 1) {
						// 	//gtag('event', 'conversion', {'send_to': 'AW-732195211/z_5UCI7a8-cBEIvTkd0C'});
						// }

						// if (cookies_advertisement == 1 || cookies_social == 1) {
						// 	//fbq('track', 'Lead');
						// }

						return false;
					}

					Swal.fire({
						//icon: 'success',
						title: 'Eroare!',
						html: response.message
					});
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		}
    };

    if ($('#history-report-request-send-btn').length) {
        historyReportRequestLead.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/history-report-request-lead.js